import { render, staticRenderFns } from "./CategoryPageDescription.vue?vue&type=template&id=9eb1c476&"
import script from "./CategoryPageDescription.vue?vue&type=script&lang=js&"
export * from "./CategoryPageDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports